<footer>
  <div class="container">
    <div class="mat-caption">
      &copy; {{ "footerComponent.copyright" | translate }}
    </div>
  </div>
</footer>
